export const GET_LG = `query GetLocationGroups ($tenantId: Int!, $accountId: Int!, $geo: GeoInputType!, $timePeriod: TimePeriod!) {
 locationGroups(tenantId: $tenantId, accountId: $accountId, geo: $geo, timePeriod: $timePeriod) {
    id
    name
    visits
    locations
    description
    accountName
    accountId 
    companyId
  }
}`

export const GET_LG_POI = `query GetLocationGroupsPois ($tagId: Int!, $geo:GeoInputType!) {
  getLocationGroupPois(tagId: $tagId, geo: $geo,) {
  id
  name
  address
  city
  state
  zip
  status
  latitude
  longitude
  }
}`

export const GET_LG_WISE_DETAILS = `query GetLocationGroupGeoWiseDetails($tagId: Int!, $accountId: Int!, $tenantId: Int!, $timePeriod: TimePeriod!){
  STATE: locationGroupGeoWiseDetails(tagId: $tagId, accountId: $accountId, tenantId: $tenantId, geoType: STATE, timePeriod: $timePeriod){
    geos {
        id
        locationCount
        visits
    }
  }

  DMA: locationGroupGeoWiseDetails(tagId: $tagId, accountId: $accountId, tenantId: $tenantId, geoType: DMA, timePeriod: $timePeriod){
    geos {
        id
        locationCount
        visits
    }
  }
}
`
